export enum PropertyType {
    Date,
    DateArray,
    CustomFields,
}

type Schema = {
    [key: string]: PropertyType | Schema | Schema[];
};

export type ResponseSchema = Schema | Schema[];
